// Identidad visual de VideoCallShop (Manual de Marca v1.0, octubre 2026).
// Única fuente de colores y tipografías: el theme de MUI, la vidriera y el
// home toman de acá. Para cambiar un color de marca, cambialo sólo en este archivo.

export const BRAND = {
    // Colores del manual
    blue: '#1D98E7', // Azul principal — color identificador
    green: '#29D2AB', // Verde turquesa — acentos y acciones
    night: '#0F1B2D', // Azul Noche — textos y fondos oscuros
    cloud: '#F2F7FB', // Nube — fondos suaves

    // Variantes derivadas (hover, superficies oscuras, texto chico legible)
    blueDark: '#0F6FB0',
    blueHover: '#1584CC',
    blueLight: '#5BB6EE',
    greenDark: '#1FB592',
    greenLight: '#5FE0C2',
    night2: '#13233A', // superficie sobre fondo Azul Noche
    night3: '#1A2E4A', // tarjetas
    night4: '#22385A', // tarjetas en hover
    textSoft: '#43536B',

    // Colores funcionales (no son de marca, se mantienen por convención)
    live: '#ff4444', // badge "EN VIVO"
    error: '#E24B4A',
};

export const FONT_FAMILY = '"Poppins", "Arial", sans-serif';

// Poppins se carga una sola vez en public/index.html.
export const FONTS_HREF =
    'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap';

// Datos de contacto y la landing para comercios
export const CONTACT = {
    whatsapp: '5493412668558',
    whatsappDisplay: '341 266 8558',
    email: 'videocallshoppping@gmail.com',
    instagram: 'videocallshop.ok',
    // Landing para comercios (ruta interna de esta app)
    landingPath: '/negocios',
};

export const whatsappLink = (text) =>
    `https://wa.me/${CONTACT.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ''}`;

// Links que vienen de datos cargados por terceros (p. ej. el link que fija
// una tienda durante la llamada): sólo se aceptan http/https, para que nadie
// pueda colar un "javascript:..." que se ejecute al tocarlo.
export const safeExternalUrl = (url) => {
    if (!url) return null;
    try {
        const raw = String(url).trim();
        // La app de la tienda acepta links sin protocolo ("tienda.com/x")
        const parsed = new URL(/^[a-z][a-z0-9+.-]*:/i.test(raw) ? raw : `https://${raw}`);
        return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? parsed.href : null;
    } catch (err) {
        return null;
    }
};
